import Cookies from 'js-cookie';
import {LoginAPI} from "./api";
import {Visibility, VisibilityOff} from '@material-ui/icons';
import '../../css/global.css';
import {AddToHomeScreen} from 'react-pwa-add-to-homescreen';
import LoginImg from "../../assets/images/login-removebg-preview.png";
import {toast, ToastContainer} from "react-toastify";
import { useState } from 'react';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);


    const toggleShowPassword = () => setShowPassword(!showPassword);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        const requestData = {
            username: username,
            password: password
        }
        try {
            const {token, message} = await LoginAPI.Login(requestData);
            console.log(token, message);
            Cookies.set('token', token, {path: '/'});
            toast.success('ورود موفقیت آمیز بود');
            setTimeout(() => {
                window.location.href = '/user-panel';
                setLoading(false);
            }, 1000);
        } catch (error) {
            toast.error('نام کاربری یا رمز عبور معتبر نیست');
            setLoading(false);
        }
    };

    const handleForgotPassword = () => {
        window.location.href = '/forgot-password';
    };

    return (
        <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <div className="row justify-content-center">
                    <div className="col-12 login-img text-center">
                        <img src={LoginImg} alt="login-img" className="img-fluid"/>
                    </div>
                    <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                        <div className="card rounded-4 border-3 border-dark mb-4">
                            <h5 className="card-header bg-dark text-white text-center">
                                ورود به حساب کاربری
                            </h5>
                            <div className="card-body">
                                <form onSubmit={handleLogin}>
                                    <label className="mb-1" htmlFor="username">کد ملی</label>
                                    <div className='mb-3'>
                                        <input
                                            type="text"
                                            className="form-control shadow"
                                            name="username"
                                            id="username"
                                            maxLength="50"
                                            placeholder='شماره ملی'
                                            value={username}
                                            disabled={loading}
                                            onChange={(e) => setUsername(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-5">
                                        <label className="mb-1" htmlFor="password">رمز عبور</label>
                                        <div className="input-group">
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                className="form-control shadow"
                                                name="password"
                                                id="password"
                                                maxLength="50"
                                                placeholder="رمز عبور"
                                                value={password}
                                                disabled={loading}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            <div onClick={toggleShowPassword} style={{
                                                zIndex: '100000',
                                                cursor: 'pointer',
                                                position: 'absolute',
                                                left: '8px',
                                                top: '6px'
                                            }}>
                                                {showPassword ? <VisibilityOff/> : <Visibility/>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-grid gap-2 rounded-2 bg-warning">
                                        <input
                                            type="submit"
                                            className="btn shadow"
                                            value='ورود'
                                            disabled={loading}
                                        />
                                    </div>
                                </form>
                            </div>
                            <div>
                                <div className="text-center">
                                    <input
                                        type="button"
                                        onClick={handleForgotPassword}
                                        className="btn"
                                        value='رمز خود را فراموش کرده اید ؟'
                                    />
                                </div>
                                <div className="text-center">
                                    <input
                                        type="button"
                                        onClick={() => window.location.href = '/register'}
                                        className="btn"
                                        value='اکانت ندارید‌؟ ثبت نام کنید'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddToHomeScreen
                appId='Saafyar'
            />
        </div>
    );
};

export default LoginPage;